module.exports = __webpack_public_path__ + "img/paul_03.40ffa957.jpg";